import download from 'downloadjs';
import moment from 'moment';

import { transformOrderApiResponse } from '@frontend/api/src/orders/editOrder';

import { toNumberOrNull } from 'utils/numberUtils';
import request from 'utils/request';

import { keysToSnakeCaseDeep } from '../utils/stringUtils';
// import type { QuoteItem } from './quoteService';
import {
  transformDateRangeToFilters,
  transformFiltersToDates,
} from './transformations';

// type ShipmentItem = {|
//   id?: Id,
//   orderItem: Id,
//   quantity: number,
// |};

//used in src/containers/EditOrder/ShippingAndShipments/Shipments.js
// export type Shipment = {|
//   id: Id,
//   supplierOrder: Id,
//   certificateOfConformanceUrl: ?string,
//   invoiceUrl: ?string,
//   packingSlipUrl: ?string,
//   pickupRecipient: ?string,
//   shipmentDate: ?Moment,
//   paymentDueDate: ?Moment,
//   shippingCost: string,
//   trackingNumber: string,
//   shipmentItems: Array<ShipmentItem>,
// |};

// type OrderItem = $Exact<{
//   orderItemId: Id,
//   leadTime: number,
//   lineItems: Array<Object>,
//   price: number,
//   unitPrice: number,
//   quantity: number,
//   quantityOutstanding: number,
//   shippingTime: number,
//   shipsOn: ?Moment,
//   options: Array<{
//     id: string,
//     isOrdered: boolean,
//     lineItems: Array<Object>,
//     quantity: number,
//     totalPrice: number,
//     unitPrice: number,
//   }>,
//   quoteItemId: ?string,
//   ...QuoteItem,
// }>;

//used in src/containers/EditOrder/CreateShipmentModal/Step1SelectQuantities.js
// export type Order = {
//   id: Id,
//   number: string,
//   quoteNumber: ?string,
//   isFromMarketplace: boolean,
//   company: string,
//   quoteNotes: ?string,
//   privateNotes: Array<Object>,
//   salesperson: string,
//   quoteItems: Array<OrderItem>,
//   quoteId: Id,
//   status: string, // TODO: list available statuses
//   price: number,
//   expeditesFee: number,
//   shippingCost: ?number,
//   taxCost: number,
//   taxRate: number,
//   totalPrice: number,
//   netPayout: number,
//   created: string,
//   shipsOn: ?Moment,
//   deliverBy: ?Moment,
//   paymentStatus: string, // TODO: list payment statuses
//   paymentTerms: ?{|
//     id: Id,
//     label: string,
//     period: number,
//   |},
//   purchaseOrderNumber: string,
//   pointOfContact: string,
//   confirmationEmail: string,
//   billingInfo: BillingInfo,
//   shippingInfo: ShippingInfo,
//   paymentInfo: Object, // TODO:
//   purchaseOrderFile: string,
//   orderInvoiceUrl: string,
//   orderRouterUrl: string,
//   shippingOption: ?{
//     type: string, // TODO: list types
//     method: string, // TODO: list methods
//     grouping: string, // TODO: list groupings
//     customerAccount: string,
//     customerCarrier: string, // TODO: list carriers
//   },
//   shipments: Array<Shipment>,
// };

const transformFacilitateData = (data) => {
  const formData = new FormData();
  if (data.poFile) {
    formData.append('po_file', data.poFile);
  }
  const snakeCasedData = keysToSnakeCaseDeep(data);
  for (const key in snakeCasedData)
    snakeCasedData[key] !== null &&
      snakeCasedData[key] !== undefined &&
      formData.append(key, snakeCasedData[key]);
  formData.append('data', JSON.stringify(snakeCasedData));
  return formData;
};

const transformOrderListParamsToApi = (params) => {
  const { status, search, page, ...filters } = params || {};
  const result = {
    status: status === 'all' ? undefined : status,
    search,
    page,
    ...filters,
  };
  return result;
};

//used in store/order/sagas.js
export const transformFiltersParamsToApi = (filters) => {
  return {
    account_in:
      filters.accountIn &&
      Array.isArray(filters.accountIn) &&
      filters.accountIn.length > 0
        ? filters.accountIn.join(',')
        : undefined,
    account_is_unassigned: filters.accountIsUnassigned
      ? filters.accountIsUnassigned
      : undefined,
    contact_in:
      filters.contactIn &&
      Array.isArray(filters.contactIn) &&
      filters.contactIn.length > 0
        ? filters.contactIn.join(',')
        : undefined,
    contact_is_unassigned: filters.contactIsUnassigned
      ? filters.contactIsUnassigned
      : undefined,
    estimator_in:
      filters.estimatorIn &&
      Array.isArray(filters.estimatorIn) &&
      filters.estimatorIn.length > 0
        ? filters.estimatorIn.join(',')
        : undefined,
    estimator_is_unassigned: filters.estimatorIsUnassigned
      ? filters.estimatorIsUnassigned
      : undefined,
    salesperson_in:
      filters.salespersonIn &&
      Array.isArray(filters.salespersonIn) &&
      filters.salespersonIn.length > 0
        ? filters.salespersonIn.join(',')
        : undefined,
    salesperson_is_unassigned: filters.salespersonIsUnassigned
      ? filters.salespersonIsUnassigned
      : undefined,
    total_price: filters.totalPrice || undefined,
    payment_status: filters.paymentStatus || undefined,
    process_in:
      filters.processIn &&
      Array.isArray(filters.processIn) &&
      filters.processIn.length > 0
        ? filters.processIn.join(',')
        : undefined,
    ...(transformDateRangeToFilters(filters.orderedDate, 'ordered') ||
      undefined),
  };
};

//used in store/order/sagas.js
export const transformApiToFiltersParams = (filters) => {
  const accountIn = [];
  let accountIsUnassigned = false;
  const contactIn = [];
  let contactIsUnassigned = false;
  const estimatorIn = [];
  let estimatorIsUnassigned = false;
  const salespersonIn = [];
  let salespersonIsUnassigned = false;
  const processIn = [];

  if (typeof filters.account_in === 'string') {
    filters.account_in.split(',').forEach((accountId) => {
      if (toNumberOrNull(accountId)) {
        accountIn.push(Number(accountId));
      }
    });
  }

  if (typeof filters.contact_in === 'string') {
    filters.contact_in.split(',').forEach((contactId) => {
      if (toNumberOrNull(contactId)) {
        contactIn.push(Number(contactId));
      }
    });
  }

  if (typeof filters.estimator_in === 'string') {
    filters.estimator_in.split(',').forEach((estimatorId) => {
      if (toNumberOrNull(estimatorId)) {
        estimatorIn.push(Number(estimatorId));
      }
    });
  }

  if (typeof filters.salesperson_in === 'string') {
    filters.salesperson_in.split(',').forEach((salespersonId) => {
      if (toNumberOrNull(salespersonId)) {
        salespersonIn.push(Number(salespersonId));
      }
    });
  }

  if (typeof filters.process_in === 'string') {
    filters.process_in.split(',').forEach((processId) => {
      if (toNumberOrNull(processId)) {
        processIn.push(Number(processId));
      }
    });
  }

  if (
    typeof filters.account_is_unassigned === 'string' &&
    filters.account_is_unassigned.toLowerCase() === 'true'
  ) {
    accountIsUnassigned = true;
  }

  if (
    typeof filters.contact_is_unassigned === 'string' &&
    filters.contact_is_unassigned.toLowerCase() === 'true'
  ) {
    contactIsUnassigned = true;
  }

  if (
    typeof filters.estimator_is_unassigned === 'string' &&
    filters.estimator_is_unassigned.toLowerCase() === 'true'
  ) {
    estimatorIsUnassigned = true;
  }

  if (
    typeof filters.salesperson_is_unassigned === 'string' &&
    filters.salesperson_is_unassigned.toLowerCase() === 'true'
  ) {
    salespersonIsUnassigned = true;
  }

  return {
    accountIn,
    accountIsUnassigned,
    contactIn,
    contactIsUnassigned,
    estimatorIn,
    estimatorIsUnassigned,
    salespersonIn,
    salespersonIsUnassigned,
    totalPrice: filters.total_price || '',
    paymentStatus: filters.payment_status || '',
    processIn,
    ...transformFiltersToDates(filters),
  };
};

const jobs = {
  get: async (jobId) => await request.get(`/orders/jobs/${jobId}`),
};

export default {
  jobs,

  list: async (groupId, params) => {
    const response = await request.get(
      `/orders/groups/${groupId}`,
      transformOrderListParamsToApi(params),
    );
    response.results = response.results.map((result) =>
      transformOrderApiResponse(result),
    );
    response.filters = {};
    response.tabCounts = response.statusCounts;
    return response;
  },

  get: async (groupId, orderId) => {
    const response = await request.get(`/orders/${orderId}?group=${groupId}`);
    return transformOrderApiResponse(response);
  },

  update: async (groupId, orderId, payload) => {
    const response = await request.patch(
      `/orders/${orderId}?group=${groupId}`,
      payload,
    );
    return transformOrderApiResponse(response);
  },

  updatePO: async (groupId, orderNumber, data) =>
    await request.put(
      `/orders/by_number/${orderNumber}/po_file?group=${groupId}`,
      data,
    ),

  copy: async (groupId, orderNumber) =>
    await request.post(
      `/orders/by_number/${orderNumber}/copy_source_quote?group=${groupId}`,
    ),

  updatePrivateNotes: async (groupId, orderNumber, text) =>
    await request.post(
      `/orders/by_number/${orderNumber}/private_notes?group=${groupId}`,
      { text },
    ),

  createShipment: async (groupId, orderNumber, payload) => {
    payload.customInvoiceNumber = payload.invoiceNumber;
    payload.shipmentDate &&
      (payload.shipmentDate = payload.shipmentDate.toISOString());
    payload.paymentDueDate &&
      (payload.paymentDueDate = payload.paymentDueDate.toISOString());
    payload.shippingInfo = payload.trackingNumber;
    payload.shippingCost = payload.additionalShippingCharge || 0;
    const response = await request.post(
      `/orders/by_number/${orderNumber}/shipments/?group=${groupId}`,
      payload,
    );
    response.shipmentDate &&
      (response.shipmentDate = moment(response.shipmentDate));
    response.paymentDueDate &&
      (response.paymentDueDate = moment(response.paymentDueDate));
    return response;
  },

  downloadInvoiceCSV: async (groupId) => {
    const response = await request.get(
      `/orders/groups/${groupId}/export_invoices`,
    );
    if (response.message) {
      return response;
    } else {
      const blob = new Blob([response], {
        type: 'text/plain',
      });
      download(blob, `orders_${moment().format('YYYYMMDD')}.csv`);
    }
  },

  downloadFiles: async (orderNumber, groupId) =>
    await request.get(
      `/orders/by_number/${orderNumber}/download_files/?group=${groupId}`,
    ),

  facilitate: async (quoteId, data) => {
    const formData = transformFacilitateData(data);
    return await request.post(`/orders/facilitate/quote/${quoteId}`, formData);
  },
};
